import styled from 'styled-components';
import Box from '@material-ui/core/Box';
import MUIAccordion from '@material-ui/core/Accordion';
import MUIAccordionDetails from '@material-ui/core/AccordionDetails';
import MUIAccordionSummary, {
  AccordionSummaryProps,
} from '@material-ui/core/AccordionSummary';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { Typography } from '@material-ui/core/styles/createTypography';
import { WithMyTheme } from '@keaze/web/theme';

import { AccordionSize } from './accordion.types';

interface CustomAccordionSummaryProps extends WithMyTheme {
  $size: AccordionSize;
}

export const Accordion = styled(MUIAccordion)`
  ${({ theme: { colors } }) => `
    border: 0;
    border-radius: 0;
    box-shadow: none;
    background-color: transparent;
    
    &:not(:last-child) {
      border-bottom: 1px solid ${colors.greys.greys5};
    }

    &::before {
      content: none;
    }

    &.Mui-expanded {
      margin: auto;
    }

    .MuiAccordionSummary-content {
      margin: 0;
    }
  `}
`;

const sizeStyle = (size: AccordionSize, typography: Typography) => {
  if (size === AccordionSize.Small) {
    return `
      font-size: ${typography.body1.fontSize};
      line-height: ${typography.body1.lineHeight};
      font-weight: 500;
    `;
  }

  return `
    font-size: ${typography.h3.fontSize};
    line-height: ${typography.h3.lineHeight};
    font-weight: ${typography.h3.fontWeight};
  `;
};

export const AccordionSummary = styled(MUIAccordionSummary)<
  CustomAccordionSummaryProps & AccordionSummaryProps
>`
  ${({
    theme: {
      palette,
      typography,
      transitions: { easing, duration },
    },
    $size,
  }: CustomAccordionSummaryProps) => `
    color: ${palette.primary.main};
    padding: 10px 0;
    transition: ${duration.standard}ms ${easing.easeInOut};
    ${sizeStyle($size, typography)};

    & .MuiAccordionSummary-expandIcon {
      transform: rotate(-90deg);
      &.Mui-expanded {
        transform: rotate(0deg);
      }
    }

    &:hover {
      color: ${palette.action.hover};
    }
  `}
`;

export const AccordionDetails = styled(MUIAccordionDetails)`
  ${({ theme: { palette, typography } }) => `
    color: ${palette.text.primary};
    font-weight: ${typography.body1.fotWeight};
    font-size: ${typography.body1.fontSize};
    line-height: ${typography.body1.lineHeight};
    padding: 0 0 22px 0;

    &.MuiAccordionDetails-root {
      display: block;
    }
  `}
`;

export const ExpandMoreIcon = styled(ExpandMore)`
  ${({ theme: { palette } }) => `
    fill: ${palette.primary.main};
    opacity: 0.3;
  `}
`;

export const Group = styled(Box)`
  margin-bottom: 17px;

  &:last-child {
    margin-bottom: 0;
  }
`;
